import { RequestMessage } from '../Messaging/RequestMessage';

export const displayOfflinePageMessageTag = 'DisplayOfflinePageMessage';

/**
 * Request to show the offline page.
 */
export class DisplayOfflinePageMessage extends RequestMessage {
  readonly tag: string = displayOfflinePageMessageTag;
}
